import { axios } from "../../util/axiosConfig";
import { incidents } from "../urls";

const closeIncident = id =>
  axios.post(incidents.close(id), { token: null }).then(response => response.data);

export default closeIncident;
